function formatPercentage(formatter, value, total, opts = {}) {
  const number = value / total;

  // eslint-disable-next-line unicorn/prefer-number-properties -- TODO: try enabling this separately
  if (isNaN(number)) {
    return opts.naNText || '';
  }
  return formatter.percent(number, opts);
}
export { formatPercentage };